module.exports = __webpack_public_path__ + "img/earth-zh.a54d5761.png";